import { ADDITIONAL_ADVISORS_SET_FULFILLED, SETTING_SET_FULFILLED, SIGN_IN_FULFILLED, SIGN_OUT } from 'Global/Stores/auth'

import { deleteToken, deleteUser, saveToken, saveUser } from 'Global/Helpers/localStorageHelpers.js'

const localStorageMiddleware = ({ dispatch, getState }) => next => action => {
  const { payload, type } = action

  if (type === ADDITIONAL_ADVISORS_SET_FULFILLED || type === SETTING_SET_FULFILLED) {
    saveUser({ ...payload.data, settings: payload.data.userSettings })
  }

  if (type === SIGN_IN_FULFILLED) {
    saveToken(payload.data.token)
    saveUser(payload.data.user)
  }

  if (type === SIGN_OUT) {
    deleteToken()
    deleteUser()
  }

  return next(action)
}

export default localStorageMiddleware
